import(/* webpackMode: "eager" */ "/app/apps/web/app/storefront/inventory/page.tsx");
